import { createSlice } from '@reduxjs/toolkit';

export const translationsSlice = createSlice({
    name: 'translations',
    initialState: {
        translations: sessionStorage.getItem("translations") 
            ? JSON.parse(sessionStorage.getItem("translations")) 
            : {},
    },
    reducers: {
        setTranslations: (state, action) => {
            state.translations = action.payload;
            if (!action.payload) {
                sessionStorage.removeItem("translations");
            } else {
                sessionStorage.setItem("translations", JSON.stringify(action.payload));
            }
        },
    },
});

export const { setTranslations } = translationsSlice.actions;

export default translationsSlice.reducer;
